<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
    <div class="box">
      <div class="block">
        <BInputWithValidation
          rules="required|max:50"
          type="text"
          label="Product"
          v-model="productCopy.name"
        />
      </div>
      <div class="block">
        <IconPicker label="Icon" v-model="product.icon" />
      </div>
      <div class="block">
        <BInputWithValidation
          rules="max:500"
          type="text"
          label="Bild-Link"
          v-model="productCopy.image_url"
        />
      </div>
      <div class="block">
        <BInputWithValidation
          rules="max:500"
          type="textarea"
          label="Description"
          v-model="productCopy.description"
        />
      </div>

      <div class="block">
        <BInputWithValidation
          rules="max:500"
          type="textarea"
          label="Notiz"
          v-model="productCopy.comment"
        />
      </div>
    </div>
    <div class="block" v-if="error">
      <b-message type="is-danger">
        <span v-html="error" />
      </b-message>
    </div>
    <div class="is-flex" style="justify-content: end">
      <b-button
        type="is-gold"
        :disabled="invalid"
        @click="handleSubmit(submit)"
      >
        {{ confirmBtnLabel }}
      </b-button>
    </div>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from "vuex";

import BInputWithValidation from "@/components/inputs/BInputWithValidation.vue";
import IconPicker from "@/components/inputs/IconPicker.vue";

export default {
  name: "ProductSimple",
  components: {
    BInputWithValidation,
    IconPicker
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    confirmBtnLabel: {
      type: String,
      default: "Speichern"
    }
  },
  data() {
    return {
      productCopy: { ...this.product }
    };
  },
  computed: {
    ...mapGetters({
      error: "product/error"
    })
  },
  watch: {
    product: {
      immediate: true,
      handler(newVal) {
        this.productCopy = { ...newVal };
      }
    }
  },
  methods: {
    submit() {
      this.$emit("submit", this.productCopy);
    }
  }
};
</script>

<style>
</style>
